import { Reducer } from 'react';
import { CandidateAction, CandidateState } from './types';
import { candidateApplicationsTableColumn } from './config';

export const InitialCandidateState: CandidateState = {
  snackbar: {
    message: '',
    state: 'success'
  },
  candidateApplicationsTableState: {
    canScroll: [false, true],
    tableHovered: false,
    density: 'Default',
    columns: candidateApplicationsTableColumn,
    selectedItemIds: [],
    selectedItems: [],
    actions: {
      selectedItem: null,
      anchorEl: null,
      isOpen: {
        delete: false,
        edit: false
      }
    },
    modalsOpen: { edit: false }
  },
  candidateApplicationsTableSettings: {
    page: 1,
    limit: 10,
    sort: 'created_at',
    sort_order: 'desc'
  },
  candidateTaskModalIsOpen: false,
  editedTask: null,
  taskWorkflowModalIsOpen: false,
  openEditModal: false,
  openDeleteModal: false,
  focused: false
};

export const CandidateReducer: Reducer<CandidateState, CandidateAction> = (
  state: CandidateState,
  action: CandidateAction
) => {
  switch (action.type) {
    case 'SET_SNACKBAR':
      return { ...state, snackbar: action.payload };
    case 'SET_CAN_SCROLL':
      return {
        ...state,
        candidateApplicationsTableState: {
          ...state.candidateApplicationsTableState,
          canScroll: action.payload
        }
      };
    case 'SET_TABLE_HOVERED':
      return {
        ...state,
        candidateApplicationsTableState: {
          ...state.candidateApplicationsTableState,
          tableHovered: action.payload
        }
      };
    case 'SET_SORT':
      return {
        ...state,
        candidateApplicationsTableSettings: {
          ...state.candidateApplicationsTableSettings,
          sort: action.payload.sortBy,
          sort_order: action.payload.sortOrder
        }
      };
    case 'SET_PAGE':
      return {
        ...state,
        candidateApplicationsTableSettings: {
          ...state.candidateApplicationsTableSettings,
          page: action.payload
        }
      };
    case 'SET_LIMIT':
      return {
        ...state,
        candidateApplicationsTableSettings: {
          ...state.candidateApplicationsTableSettings,
          limit: action.payload
        }
      };
    case 'OPEN_TASK_MODAL':
      return { ...state, candidateTaskModalIsOpen: action.payload };
    case 'SET_EDITED_TASK':
      return { ...state, editedTask: action.payload };
    case 'OPEN_TASK_WORKFLOW_MODAL':
      return { ...state, taskWorkflowModalIsOpen: action.payload };
    case 'OPEN_EDIT_MODAL':
      return { ...state, openEditModal: action.payload };
    case 'OPEN_DELETE_MODAL':
      return { ...state, openDeleteModal: action.payload };
    case 'SET_FOCUSED':
      return { ...state, focused: action.payload };
    default:
      return state;
  }
};
